import { serverFetch } from "@core/server";

export function fetchSprNumberCatList() {
  return serverFetch("sprs/number-cat");
}

export function fetchSprNumberCat(idNumberCat) {
  return serverFetch(`sprs/number-cat/${idNumberCat}`);
}

export function fetchSprNumberCatMealTypes() {
  return serverFetch("sprs/number-cat/meal-types");
}

export function createSprNumberCat(bodyData) {
  return serverFetch("sprs/number-cat", {
    method: "POST",
    bodyData
  });
}

export function saveSprNumberCat(bodyData) {
  return serverFetch("sprs/number-cat", {
    method: "PUT",
    bodyData
  });
}

export function deleteSprNumberCat(idNumberCat) {
  return serverFetch(`sprs/number-cat/${idNumberCat}`, {
    method: "DELETE"
  });
}
